import React, { useState, useEffect } from 'react';
import {  FaEdit } from "react-icons/fa";
import { IoInformationCircleOutline } from "react-icons/io5";
import PropagateLoader from "react-spinners/PropagateLoader";
import { Tooltip } from 'react-tooltip';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { useDispatch, useSelector } from 'react-redux';
import { quizListRes, quizListTodo } from '../../LMS_Redux/LMS_Slices/Quiz/QuizList';
import { useNavigate } from 'react-router-dom';
import QuizDetails from './QuizDetails';
import { quizDetailsRes, quizDetailsTodo } from '../../LMS_Redux/LMS_Slices/Quiz/QuizDetails';

export default function QuizList() {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const data = useSelector(state => state.quizList && state.quizList.data && state.quizList.data.data)
    const [loading, setLoading] = useState(false)
    const [detailModal, setDetailModal] = useState(false)
    const [modalLoading, setModalLoading] = useState(true)

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 100
        },
        {
            headerName: 'QUIZ TITLE',
            field: 'quiz_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        // {
        //     headerName: 'DEPARTMENT',
        //     field: 'department_data',
        //     valueFormatter: function (params) {
        //         return params.data && params.data.department_data && params.data.department_data.map(val => `${val.label}`).join(',')
        //     },
        //     filter: 'agTextColumnFilter',
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: true,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => <span className={params.value == 'active' ? 'badge text-bg-success' : 'badge text-bg-danger'} style={{ textTransform: 'capitalize' }}>{params.value}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED BY',
            field: 'created_by',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <IoInformationCircleOutline  size={20} className='eye'
                        onClick={() => quiz_details(params)}
                        data-tooltip-id='details'
                        data-tooltip-content="Quiz Details!"
                        data-tooltip-place="bottom"
                    />
                    {params.data.isEditable ?
                        <FaEdit size={20} className='edit ms-3'
                            onClick={() => edit_quiz(params)}
                            data-tooltip-id='edit'
                            data-tooltip-content="Edit Quiz!"
                            data-tooltip-place="bottom"
                        />
                        : ''
                    }

                    <Tooltip id='details' style={{ backgroundColor: "rgb(34, 98, 198)", zIndex: '9', lineHeight: 'normal' }} />
                    <Tooltip id='edit' style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            // wrapText: true,
            autoHeight: true,
        }
    ]);

    const edit_quiz = (params) => {
        navigate('/create_quiz', { state: params.data })
    }

    const quiz_details = (params) => {
        setModalLoading(true)
        setDetailModal(true)
        dispatch(quizDetailsTodo(params.data.id)).then(() => quiz_details_res())
    }

    const quiz_details_res = () => {
        if (quizDetailsRes && quizDetailsRes.success) {
            setModalLoading(false)
        } else {
            setModalLoading(false)
        }
    }

    const quiz_res = () => {
        if (quizListRes && quizListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(quizListTodo({ "department": [], "status": '', "temp": 'list' })).then(() => quiz_res())
    }, [])

    return (
        <>
            <section>
                <div className='container-fluid'>
                    <div className='scnd-header'>
                        <span className='icon1'>Quiz Management / </span>
                        <span className='icon2'>Quiz List</span>
                    </div>
                    {loading ?
                        <div className='wrapper-admin'>
                            <div className='text-center mb-3'>
                                <PropagateLoader
                                    color="#2262C6"
                                    size={20}
                                />
                            </div>
                        </div>
                        :
                        <DataTables
                            rowData={data}
                            columnDefs={columnDefs}
                        />
                    }
                </div>
            </section>

            <QuizDetails detailModal={detailModal} setDetailModal={setDetailModal} modalLoading={modalLoading} setModalLoading={setModalLoading} />
        </>
    )
}